import React from "react";

function DataCard({ title, value, image }) {
    return (
        <div className="p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-shadow duration-300 ease-in-out flex items-center justify-between border border-gray-200">
            <div className="flex flex-col gap-1">
                <h4 className="text-gray-500 text-sm font-medium">{title}</h4>
                <span className="text-2xl font-extrabold text-gray-800 mt-1">{value}</span>
            </div>
            <div className="bg-purple-100 text-purple-600 rounded-2xl p-3 flex items-center justify-center shadow-md">
                {image}
            </div>
        </div>
    );
}

export default DataCard;
